import { computed, inject, Service, signal } from '@angular/core';
import { MgsWebApi } from '../mgs-webapi.service';
import { firstValueFrom } from 'rxjs';
import { PartnerService } from './partner.service';
import { IOption, withEmptyOption } from '@mng/mng-inputs';

@Service()
export class BuchungPartnerService {
  readonly #mgsWebApi = inject(MgsWebApi);

  #buchungPartnerIds = signal<number[]>([]);
  buchungPartnerIds = this.#buchungPartnerIds.asReadonly();

  readonly partnerService = inject(PartnerService);

  buchungPartner = computed(() => this.buchungPartnerIds().map((partnerId) => this.partnerService.partner(partnerId)));
  buchungPartnerOptions = computed(() =>
    withEmptyOption(
      this.buchungPartner().map((partner) => ({ name: partner.name, value: partner.id }) as IOption),
      true,
      'Kein Buchungspartner',
      null
    )
  );

  async resolveBuchungPartnerDaten() {
    const ids = await firstValueFrom(this.#mgsWebApi.buchungPartnerIdsErmittlung());
    this.#buchungPartnerIds.set(ids);
  }

  isBuchungPartner(partnerId: number): boolean {
    return this.buchungPartnerIds().includes(partnerId);
  }
}
